import { APIClient } from './api-client'

/**
 * Wallet API client.
 * The Wallet service is a stub so far, the client only offers the status check
 * inherited from the base class and will grow together with the service.
 */
export class WalletAPIClient extends APIClient {
  /**
   * Returns API name served by this client
   */
  get name () {
    return 'Wallet'
  }
}
